import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { portalApi } from "./portalApi";
import { Receivable } from "../types/dtos";

export type PortalSettingsFlags = {
  showFullHistory5y: boolean;
};

export function usePortalSettings(): UseQueryResult<PortalSettingsFlags> {
  return useQuery({
    queryKey: ["portal", "settings"],
    queryFn: async () => (await portalApi.get<PortalSettingsFlags>("/portal/settings")).data,
  });
}

export function usePortalReceivables(): UseQueryResult<Receivable[]> {
  return useQuery({
    queryKey: ["portal", "receivables"],
    queryFn: async () => (await portalApi.get<Receivable[]>("/portal/receivables")).data,
  });
}
